import { FC } from 'react'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface TravelerCounterProps {
  title: string
  hint: string
  value: number
  min: number
  max: number
  onChange: (value: number) => void
}

export const TravelerCounter: FC<TravelerCounterProps> = ({
  title,
  hint,
  value,
  min,
  max,
  onChange,
}) => (
  <div className={s.root}>
    <div className={s.description}>
      <p className={clsx(s.title, 'medium-16')}>{title}</p>
      <div className={s.hint}>
        <AppIcon
          id={AllIcons.INFO_TRIANGLE}
          width={16}
          height={16}
        />
        <span className="medium-12">{hint}</span>
      </div>
    </div>

    <div className={s.controls}>
      <button
        type="button"
        className={s.counterButton}
        disabled={value <= min}
        aria-label={`− ${title}`}
        onClick={() => onChange(value - 1)}
      >
        <AppIcon
          id={AllIcons.MINUS}
          width={16}
          height={16}
        />
      </button>
      <span className={clsx(s.value, 'semi-bold-16')}>{value}</span>
      <button
        type="button"
        className={clsx(s.counterButton, s.addButton)}
        disabled={value >= max}
        aria-label={`+ ${title}`}
        onClick={() => onChange(value + 1)}
      >
        <AppIcon
          id={AllIcons.PLUS}
          width={16}
          height={16}
        />
      </button>
    </div>
  </div>
)
